export default __webpack_public_path__ + "static/media/icon_checklists.b3d463b9.svg";